import React from 'react';
import { useNavigate } from 'react-router-dom';
import MedConnectCalendar from '../api/calendar';

export const EventsPage = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      backgroundColor: "#d7ffd9",
      color: "#1b5e20",
      minHeight: "100vh",
      padding: "30px",
      paddingTop: "100px",
    },
    heading: {
      marginTop: 0,
      marginBottom: "30px",
      fontSize: "2.25rem",
      color: "#1b5e20",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
    calendarWrapper: {
      backgroundColor: "#c8e6c9",
      borderRadius: "12px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
      padding: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    aboutButtonsWrapper: {
      display: "flex",
      gap: "12px",
      marginBottom: "30px",
      flexWrap: "wrap",
    },
    aboutButton: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #2e7d32",
      backgroundColor: "transparent",
      color: "#1b5e20",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    aboutButtonActive: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #1b5e20",
      backgroundColor: "#2e7d32",
      color: "white",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "default",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Events</h1>
      <div style={styles.aboutButtonsWrapper}>
        <button onClick={() => navigate('/meet-the-team')} style={styles.aboutButton}>Meet the Team</button>
        <button onClick={() => navigate('/locations')} style={styles.aboutButton}>Locations</button>
        <button style={styles.aboutButtonActive} aria-current="page">Events</button>
      </div>
      <div style={styles.calendarWrapper}>
        <MedConnectCalendar />
      </div>
    </div>
  );
};
